// QRM-524: fine weight steps — 10g for per-100g products (unitSellCode 2),
// 100g for per-kg products (unitSellCode 3).
// Click&Collect build only for now: the QR-menu dine-in table path has to be
// verified with fractional counts on prod first. To enable everywhere,
// replace the env check with `true`.
export const FINE_WEIGHT_STEPS_ENABLED = process.env.REACT_APP_IS_CLIC === '1'

export type AmountConfig = {
  // in count units: unitSellCode 2 → portions of 100g, unitSellCode 3 → kg
  step: number
  multiplier: number
  minAmount: number
  coarseStep?: number
  fineLabel?: string
  coarseLabel?: string
  unit?: string
}

export const getAmountConfig = (sellCode: number | null): AmountConfig => {
  if (sellCode === 2) {
    return FINE_WEIGHT_STEPS_ENABLED
      ? {
          step: 0.1,
          coarseStep: 1,
          multiplier: 100,
          minAmount: 1,
          fineLabel: '10',
          coarseLabel: '100',
          unit: 'g',
        }
      : { step: 1, multiplier: 100, minAmount: 1 }
  }
  if (sellCode === 3) {
    return FINE_WEIGHT_STEPS_ENABLED
      ? {
          step: 0.1,
          coarseStep: 1,
          multiplier: 1,
          minAmount: 0.1,
          fineLabel: '100g',
          coarseLabel: '1kg',
          unit: 'kg',
        }
      : { step: 0.1, multiplier: 1, minAmount: 0.1 }
  }
  return { step: 1, multiplier: 1, minAmount: 1 }
}
